var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSablier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 32.768,
    height: 43.018,
    fill: "#4188f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_357",
    "data-name": "Groupe 357",
    transform: "translate(-625 -5117)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "translate(625 5117)",
    fill: "#d9e7fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_107",
    "data-name": "Groupe 107",
    transform: "translate(648.116 5134.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_94",
    "data-name": "Groupe 94",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_514",
    "data-name": "Trac\\xE9 514",
    d: "M29.936,35.577l-2.4-7.209a11.7,11.7,0,0,0-5.857-6.779,12.167,12.167,0,0,0,5.857-6.939c.253-.76,2.15-6.45,2.4-7.209A3.781,3.781,0,0,0,28.987,0H3.781a3.781,3.781,0,0,0-.949,7.441c.253.759,2.15,6.449,2.4,7.209a12.157,12.157,0,0,0,5.856,6.938,11.7,11.7,0,0,0-5.856,6.78l-2.4,7.209a3.781,3.781,0,0,0,.949,7.441H28.987a3.781,3.781,0,0,0,.949-7.441M3.781,5.041a1.26,1.26,0,0,1,0-2.521H28.987a1.26,1.26,0,0,1,0,2.521ZM5.53,7.562H27.238L25.558,12.6H7.21Zm2.622,7.554H24.616a9.378,9.378,0,0,1-4.784,4.55c-.247.1-.042-.045-3.44,2.8-3.253-2.773-3.072-2.649-3.339-2.753a9.363,9.363,0,0,1-4.9-4.6m-.525,14.05A9.187,9.187,0,0,1,13.5,23.314l2.064,1.759a1.26,1.26,0,0,0,1.626.008l2.1-1.757a9.192,9.192,0,0,1,5.849,5.843l2.1,6.291H22.9c-1.018-3.056-3.3-7.562-6.517-7.562s-5.5,4.507-6.517,7.562H5.53Zm12.611,6.291H12.53a14.968,14.968,0,0,1,1.7-3.287c.775-1.1,1.582-1.754,2.158-1.754s1.383.656,2.158,1.754a14.96,14.96,0,0,1,1.7,3.287M28.987,40.5H3.781a1.26,1.26,0,0,1,0-2.521H28.987a1.26,1.26,0,0,1,0,2.521",
    fill: "#4188f2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSablier);
export default __webpack_public_path__ + "static/media/sablier.576536a65982bf2d1f6c738050f4b7b3.svg";
export { ForwardRef as ReactComponent };